import axios, { AxiosError } from "axios";
import { useMutation } from "react-query";

const CancelEmployeeImportDataApiService = async (
  request: number
): Promise<boolean> => {
  const uri = `/employeeimportfiles/${request}/cancel/`;
  const { data } = await axios.post(uri);
  return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useCancelEmployeeImportDataApiService = () =>
  useMutation<boolean, AxiosError, number>(
    "CancelEmployeeImportDataApiService",
    CancelEmployeeImportDataApiService
  );

export default useCancelEmployeeImportDataApiService;
